<div class="add_new_md">
    
    <form [formGroup]="linkQRCodeForm" (ngSubmit)="linkQR()">
       <div class="add-header">
        <div class="md-header">
            <div class="row">
                <div class="col-sm-6">
                  Link QR code
                </div>
                <div class="col-sm-3">
                    
                </div>
                <div class="col-sm-3" style="text-align: right;">
                    <button type="button" class="cenl_btn" (click)="closePopup()">X</button>
                </div>
            </div>
        </div>
       </div>
           
        
        <div class="add_scroll">
            <div class="ad_ox">
             
               
               
                <div class="form-group">
                    <label for="qrCode">QR code</label>
                    <input type="text" id="qrCode" autocomplete="off" formControlName="code" placeholder="Enter code">
                </div>
               
                
               
               
              
                   </div>
        </div>

        <div class="add_footer">
            <div class="md-footer">
                <div class="row">
                    <div class="col-sm-6">
                    </div>
                    <div class="col-sm-3">
                        <button type="button" class="cenl_btn" (click)="closePopup()">Cancel</button>
                    </div>
                    <div class="col-sm-3">
                        <button type="submit" [disabled]="linkQRCodeForm.invalid">Link QR</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
